<template>
  <div class="sem-resultado-container">
    <div :key="getRenderKey" class="box-sem-resultado-corpo">
      <div>
        <font-awesome-icon icon="file-alt" />
      </div>
      <div>
        <p>
          Não há previsão legal de
          <b>{{
            titulo.toUpperCase() == "ICMS ANTECIPAÇÃO"
              ? `${titulo.toUpperCase()}`
              : titulo.toUpperCase()
          }}</b
          >{{
            titulo.toUpperCase() == "ICMS ANTECIPAÇÃO" ? " Com Encerramento de Tributação" : ""
          }}
          no cenário proposto.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";

import { mapGetters } from "vuex";

export default {
  name: "ImpostoSemResultado",

  props: {
    titulo: String
  },

  components: {
    QuadroPrincipal
  },

  data() {
    return {};
  },

  mounted() {},

  computed: {
    ...mapGetters("reRender", ["getRenderKey"])
  },

  methods: {}
};
</script>

<style lang="scss" scoped>
.box-sem-resultado-corpo {
  height: 140px;
  width: 80%;
  margin: 0px auto;
  border: 2px solid #e6e6e6;
  background: #ececec;
  padding: 0px 25px;
  font-size: 15px;
  color: #999;
  display: flex;
  justify-content: center;
  align-items: center;
  // cursor: pointer;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;

    &:first-child {
      padding: 0 20px;
      border-right: 1px solid #999;
    }

    &:last-child {
      margin: 0 10px;
      p {
        margin: 0 0 0 10px;
      }
    }

    .svg-inline--fa {
      font-size: 44px;
      margin-left: 0px;
    }
  }
}
.sem-resultado-container {
  display: flex;
  justify-content: center;
  align-items: center;

  min-height: 184px;
}
</style>
